window.zmzLoadMore = async (button) => {
    const gridContainer = document.querySelector('.product-grid');
    const loadMoreWrapper = document.querySelector('#zmz-load-more');
    const loadMoreSpinner = loadMoreWrapper.querySelector('.load-more__spinner');
    const paginationList = document.querySelector('.pagination__list');
  
    gridContainer.classList.add('loading');
    loadMoreSpinner.classList.remove('hidden');
    button.classList.add('hidden');
  
    const nextDataUrl = button.getAttribute('data-next-url');
    const replacedUrl = nextDataUrl.toString();
    const nextUrl = replacedUrl.replace(/^(.*?\/?page\/?)(\d\d?\d?)(.*?$)/,/^(.*?\/?\?page=)(\d\d?\d?)(.*?$)/,/(.*?)(\d\d?\d?)(?!.*\d)(.*?$)/); 
    
    try {
      const response = await fetch(nextUrl);
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`); 
      }
  
      const data = await response.text();
      const parser = new DOMParser();
      const newPage = parser.parseFromString(data, 'text/html');
  
      if (newPage) {
        gridContainer.classList.remove('loading'); 
        loadMoreSpinner.classList.add('hidden');
        button.classList.remove('hidden');
  
        const grid = document.querySelector('[data-grid-js]');
        grid.innerHTML += newPage.querySelector('[data-grid-js]').innerHTML; 

        loadMoreWrapper.replaceWith(newPage.querySelector('#zmz-load-more'));
        if (paginationList) {
          paginationList.replaceWith(newPage.querySelector('.pagination'));
        }
        activeCompare();
        activeWishlist();
      }
  
      const event = new CustomEvent('zmz.paginate.next');
      document.querySelector('#zmz-load-more').dispatchEvent(event);
      if (paginationList) {
        document.querySelector('.pagination').dispatchEvent(event);
      }
    } catch {
        throw new Error('Failed to load more products');
    } finally {
        gridContainer.classList.remove('loading');
        loadMoreSpinner.classList.add('hidden');
    }
  };
  